// extracted by mini-css-extract-plugin
export default {"container":"dashboard-list_container__CvQTo","scroll-container":"dashboard-list_scroll-container__O07co"};